import { HOST, OSTICKET_PROXY, OSTICKET_API_KEY, OSTICKET_ROOT_USER } from '../config';
import { apiDelete, apiGet, apiPost, apiPut, CancelToken } from '../api';

import { getStateForButtonFilter, parseError } from '../helpers';
import { ORDERS_PAGE_TABS } from '../config';
import axios from 'axios';
import { clearConfigCache } from 'prettier';
import { toast } from 'react-toastify';
import { hideModal } from './modal';
import { cancelSources } from '../config/cancelAxiosRequest';

const osTicketConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

const setOsticketHeaders = (getState) => {
  if (OSTICKET_PROXY) {
    osTicketConfig.headers['Authorization'] = 'Bearer ' + getState().auth.tokenData.access_token;
  } else {
    //Доступ к osticket без прокси. Из соображений безопасности OSTICKET_API_KEY на клиенте можно применять только для локальных и тестовых копий osTicket. Поскольку зная его получаем доступ к тикетам всех пользователей.
    osTicketConfig.headers['X-API-Key'] = OSTICKET_API_KEY;
    osTicketConfig.headers['User-Login'] = getState().auth.account.login;
    //ToDo по хорошему здесь надо считывать логин корневого пользователя из списка пользователей аккаунта. Но поскольку этот режим применяется только для отладки, пока сделана просто константа
    osTicketConfig.headers['Account'] = OSTICKET_ROOT_USER;
  }
};

export const A = {
  REQUEST_GET_ORDERS: 'REQUEST_GET_ORDERS',
  RECEIVE_GET_ORDERS: 'RECEIVE_GET_ORDERS',
  ERROR_GET_ORDERS: 'ERROR_GET_ORDERS',

  REQUEST_GET_ORDER_BY_ID: 'REQUEST_GET_ORDER_BY_ID',
  RECEIVE_GET_ORDER_BY_ID: 'RECEIVE_GET_ORDER_BY_ID',
  ERROR_GET_ORDER_BY_ID: 'ERROR_GET_ORDER_BY_ID',

  REQUEST_GET_ORDERS_STATUSES_LENGTH: 'REQUEST_GET_ORDERS_STATUSES_LENGTH',
  RECEIVE_GET_ORDERS_STATUSES_LENGTH: 'RECEIVE_GET_ORDERS_STATUSES_LENGTH',
  ERROR_GET_ORDERS_STATUSES_LENGTH: 'ERROR_GET_ORDERS_STATUSES_LENGTH',

  REQUEST_GET_NEAREST_ORDERS: 'REQUEST_GET_NEAREST_ORDERS',
  RECEIVE_GET_NEAREST_ORDERS: 'RECEIVE_GET_NEAREST_ORDERS',
  ERROR_GET_NEAREST_ORDERS: 'ERROR_GET_NEAREST_ORDERS',

  REQUEST_CREATE_ORDER: 'REQUEST_CREATE_ORDER',
  RECEIVE_CREATE_ORDER: 'RECEIVE_CREATE_ORDER',
  ERROR_CREATE_ORDER: 'ERROR_CREATE_ORDER',

  REQUEST_UPDATE_ORDER: 'REQUEST_UPDATE_ORDER',
  RECEIVE_UPDATE_ORDER: 'RECEIVE_UPDATE_ORDER',
  ERROR_UPDATE_ORDER: 'ERROR_UPDATE_ORDER',

  REQUEST_CONFIRM_ORDER: 'REQUEST_CONFIRM_ORDER',
  RECEIVE_CONFIRM_ORDER: 'RECEIVE_CONFIRM_ORDER',
  ERROR_CONFIRM_ORDER: 'ERROR_CONFIRM_ORDER',

  REQUEST_CANCEL_ORDER: 'REQUEST_CANCEL_ORDER',
  RECEIVE_CANCEL_ORDER: 'RECEIVE_CANCEL_ORDER',
  ERROR_CANCEL_ORDER: 'ERROR_CANCEL_ORDER',

  REQUEST_UPDATE_ORDER_ITEMS: 'REQUEST_UPDATE_ORDER_ITEMS',
  RECEIVE_UPDATE_ORDER_ITEMS: 'RECEIVE_UPDATE_ORDER_ITEMS',
  ERROR_UPDATE_ORDER_ITEMS: 'ERROR_UPDATE_ORDER_ITEMS',

  REQUEST_UPDATE_ORDER_CLIENT: 'REQUEST_UPDATE_ORDER_CLIENT',
  RECEIVE_UPDATE_ORDER_CLIENT: 'RECEIVE_UPDATE_ORDER_CLIENT',
  ERROR_UPDATE_ORDER_CLIENT: 'ERROR_UPDATE_ORDER_CLIENT',

  REQUEST_GET_DELIVERY_INFO: 'REQUEST_GET_DELIVERY_INFO',
  RECEIVE_GET_DELIVERY_INFO: 'RECEIVE_GET_DELIVERY_INFO',
  ERROR_GET_DELIVERY_INFO: 'ERROR_GET_DELIVERY_INFO',

  REQUEST_GET_WAREHOUSES: 'REQUEST_GET_WAREHOUSES',
  RECEIVE_GET_WAREHOUSES: 'RECEIVE_GET_WAREHOUSES',
  ERROR_GET_WAREHOUSES: 'ERROR_GET_WAREHOUSES',

  REQUEST_CALC_INSURANCE_SUM: 'REQUEST_CALC_INSURANCE_SUM',
  RECEIVE_CALC_INSURANCE_SUM: 'RECEIVE_CALC_INSURANCE_SUM',
  ERROR_CALC_INSURANCE_SUM: 'ERROR_CALC_INSURANCE_SUM',

  REQUEST_REFRESH_RESERVE_BATCH: 'REQUEST_REFRESH_RESERVE_BATCH',
  RECEIVE_REFRESH_RESERVE_BATCH: 'RECEIVE_REFRESH_RESERVE_BATCH',
  ERROR_REFRESH_RESERVE_BATCH: 'ERROR_REFRESH_RESERVE_BATCH',

  REQUEST_REFRESH_RESERVE: 'REQUEST_REFRESH_RESERVE',
  RECEIVE_REFRESH_RESERVE: 'RECEIVE_REFRESH_RESERVE',
  ERROR_REFRESH_RESERVE: 'ERROR_REFRESH_RESERVE',

  REQUEST_UPDATE_PAYMENT_STATUS: 'REQUEST_UPDATE_PAYMENT_STATUS',
  RECEIVE_UPDATE_PAYMENT_STATUS: 'RECEIVE_UPDATE_PAYMENT_STATUS',
  ERROR_UPDATE_PAYMENT_STATUS: 'ERROR_UPDATE_PAYMENT_STATUS',

  REQUEST_GET_ORDER_HISTORY: 'REQUEST_GET_ORDER_HISTORY',
  RECEIVE_GET_ORDER_HISTORY: 'RECEIVE_GET_ORDER_HISTORY',
  ERROR_GET_ORDER_HISTORY: 'ERROR_GET_ORDER_HISTORY',

  REQUEST_GET_ORDERS_EXPORT_TASKS: 'REQUEST_GET_ORDERS_EXPORT_TASKS',
  RECEIVE_GET_ORDERS_EXPORT_TASKS: 'RECEIVE_GET_ORDERS_EXPORT_TASKS',
  ERROR_GET_ORDERS_EXPORT_TASKS: 'ERROR_GET_ORDERS_EXPORT_TASKS',

  REQUEST_GET_ORDERS_REPORT: 'REQUEST_GET_ORDERS_REPORT',
  RECEIVE_GET_ORDERS_REPORT: 'RECEIVE_GET_ORDERS_REPORT',
  ERROR_GET_ORDERS_REPORT: 'ERROR_GET_ORDERS_REPORT',

  REQUEST_GET_ORDER_STICKER: 'REQUEST_GET_ORDER_STICKER',
  RECEIVE_GET_ORDER_STICKER: 'RECEIVE_GET_ORDER_STICKER',
  ERROR_GET_ORDER_STICKER: 'ERROR_GET_ORDER_STICKER',

  REQUEST_COPY_ORDER: 'REQUEST_COPY_ORDER',
  RECEIVE_COPY_ORDER: 'RECEIVE_COPY_ORDER',
  ERROR_COPY_ORDER: 'ERROR_COPY_ORDER',

  REQUEST_UPDATE_ORDER_ADDRESS: 'REQUEST_UPDATE_ORDER_ADDRESS',
  RECEIVE_UPDATE_ORDER_ADDRESS: 'RECEIVE_UPDATE_ORDER_ADDRESS',
  ERROR_UPDATE_ORDER_ADDRESS: 'ERROR_UPDATE_ORDER_ADDRESS',

  REQUEST_TAGS: 'REQUEST_TAGS',

  REQUEST_UPLOAD_ORDER_FILE: 'REQUEST_UPLOAD_ORDER_FILE',
  RECEIVE_UPLOAD_ORDER_FILE: 'RECEIVE_UPLOAD_ORDER_FILE',
  ERROR_UPLOAD_ORDER_FILE: 'ERROR_UPLOAD_ORDER_FILE',

  REQUEST_DELETE_ORDER_FILE: 'REQUEST_DELETE_ORDER_FILE',
  RECEIVE_DELETE_ORDER_FILE: 'RECEIVE_DELETE_ORDER_FILE',
  ERROR_DELETE_ORDER_FILE: 'ERROR_DELETE_ORDER_FILE',

  REQUEST_EDIT_ORDER_FILE: 'REQUEST_EDIT_ORDER_FILE',
  RECEIVE_EDIT_ORDER_FILE: 'RECEIVE_EDIT_ORDER_FILE',
  ERROR_EDIT_ORDER_FILE: 'ERROR_EDIT_ORDER_FILE',

  REQUEST_EMAIL_REPEAT: 'REQUEST_EMAIL_REPEAT',
  RECEIVE_EMAIL_REPEAT: 'RECEIVE_EMAIL_REPEAT',
  ERROR_EMAIL_REPEAT: 'ERROR_EMAIL_REPEAT',

  REQUEST_UPDATE_ORDER_DELIVERY: 'REQUEST_UPDATE_ORDER_DELIVERY',
  RECEIVE_UPDATE_ORDER_DELIVERY: 'RECEIVE_UPDATE_ORDER_DELIVERY',
  ERROR_UPDATE_ORDER_DELIVERY: 'ERROR_UPDATE_ORDER_DELIVERY',

  REQUEST_UPDATE_ORDER_DISCOUNTS: 'REQUEST_UPDATE_ORDER_DISCOUNTS',
  RECEIVE_UPDATE_ORDER_DISCOUNTS: 'RECEIVE_UPDATE_ORDER_DISCOUNTS',
  ERROR_UPDATE_ORDER_DISCOUNTS: 'ERROR_UPDATE_ORDER_DISCOUNTS',

  REQUEST_UPDATE_ORDER_COMMENT: 'REQUEST_UPDATE_ORDER_COMMENT',
  RECEIVE_UPDATE_ORDER_COMMENT: 'RECEIVE_UPDATE_ORDER_COMMENT',
  ERROR_UPDATE_ORDER_COMMENT: 'ERROR_UPDATE_ORDER_COMMENT',

  REQUEST_GET_WORKSHEET_FORM_TEMPLATE: 'REQUEST_GET_WORKSHEET_FORM_TEMPLATE',
  RECEIVE_GET_WORKSHEET_FORM_TEMPLATE: 'RECEIVE_GET_WORKSHEET_FORM_TEMPLATE',
  ERROR_GET_WORKSHEET_FORM_TEMPLATE: 'ERROR_GET_WORKSHEET_FORM_TEMPLATE',

  REQUEST_GET_WORKSHEET: 'REQUEST_GET_WORKSHEET',
  RECEIVE_GET_WORKSHEET: 'RECEIVE_GET_WORKSHEET',
  RECEIVE_GET_WORKSHEET_SHIPMENT_CODE: 'RECEIVE_GET_WORKSHEET_SHIPMENT_CODE',
  ERROR_GET_WORKSHEET: 'ERROR_GET_WORKSHEET',

  REQUEST_UPDATE_WORKSHEET: 'REQUEST_UPDATE_WORKSHEET',
  RECEIVE_UPDATE_WORKSHEET: 'RECEIVE_UPDATE_WORKSHEET',
  ERROR_UPDATE_WORKSHEET: 'ERROR_UPDATE_WORKSHEET',

  REQUEST_UPLOAD_FBM_DOCS_FF: 'REQUEST_UPLOAD_FBM_DOCS_FF',
  RECEIVE_UPLOAD_FBM_DOCS_FF: 'RECEIVE_UPLOAD_FBM_DOCS_FF',
  ERROR_UPLOAD_FBM_DOCS_FF: 'ERROR_UPLOAD_FBM_DOCS_FF',

  REQUEST_UPLOAD_FBM_STICKERS_XLS: 'REQUEST_UPLOAD_FBM_STICKERS_XLS',
  RECEIVE_UPLOAD_FBM_STICKERS_XLS: 'RECEIVE_UPLOAD_FBM_STICKERS_XLS',
  ERROR_UPLOAD_FBM_STICKERS_XLS: 'ERROR_UPLOAD_FBM_STICKERS_XLS',

  REQUEST_GET_FBM_BARCODES_XLS: 'REQUEST_GET_FBM_BARCODES_XLS',
  RECEIVE_GET_FBM_BARCODES_XLS: 'RECEIVE_GET_FBM_BARCODES_XLS',
  ERROR_GET_FBM_BARCODES_XLS: 'ERROR_GET_FBM_BARCODES_XLS',

  REQUEST_UPLOAD_FBM_STICKERS_PALLET_FILE: 'REQUEST_UPLOAD_FBM_STICKERS_PALLET_FILE',
  RECEIVE_UPLOAD_FBM_STICKERS_PALLET_FILE: 'RECEIVE_UPLOAD_FBM_STICKERS_PALLET_FILE',
  ERROR_UPLOAD_FBM_STICKERS_PALLET_FILE: 'ERROR_UPLOAD_FBM_STICKERS_PALLET_FILE',

  REQUEST_DELETE_FBM_STICKERS_PALLET_FILE: 'REQUEST_DELETE_FBM_STICKERS_PALLET_FILE',
  RECEIVE_DELETE_FBM_STICKERS_PALLET_FILE: 'RECEIVE_DELETE_FBM_STICKERS_PALLET_FILE',
  ERROR_DELETE_FBM_STICKERS_PALLET_FILE: 'ERROR_DELETE_FBM_STICKERS_PALLET_FILE',

  REQUEST_EDIT_FBM_STICKERS_PALLET_FILE: 'REQUEST_EDIT_FBM_STICKERS_PALLET_FILE',
  RECEIVE_EDIT_FBM_STICKERS_PALLET_FILE: 'RECEIVE_EDIT_FBM_STICKERS_PALLET_FILE',
  ERROR_EDIT_FBM_STICKERS_PALLET_FILE: 'ERROR_EDIT_FBM_STICKERS_PALLET_FILE',

  REQUEST_UPLOAD_FBM_STICKERS_PACKING_FILE: 'REQUEST_UPLOAD_FBM_STICKERS_PACKING_FILE',
  RECEIVE_UPLOAD_FBM_STICKERS_PACKING_FILE: 'RECEIVE_UPLOAD_FBM_STICKERS_PACKING_FILE',
  ERROR_UPLOAD_FBM_STICKERS_PACKING_FILE: 'ERROR_UPLOAD_FBM_STICKERS_PACKING_FILE',

  REQUEST_ORDER_EXCLUDE_CHANGE: 'REQUEST_ORDER_EXCLUDE_CHANGE',
  RECEIVE_ORDER_EXCLUDE_CHANGE: 'RECEIVE_ORDER_EXCLUDE_CHANGE',
  ERROR_ORDER_EXCLUDE_CHANGE: 'ERROR_ORDER_EXCLUDE_CHANGE',

  REQUEST_GET_ORDERS_RETURNS: 'REQUEST_GET_ORDERS_RETURNS',
  RECEIVE_GET_ORDERS_RETURNS: 'RECEIVE_GET_ORDERS_RETURNS',
  ERROR_GET_ORDERS_RETURNS: 'ERROR_GET_ORDERS_RETURNS',

  REQUEST_POST_ORDERS_RETURNS: 'REQUEST_POST_ORDERS_RETURNS',
  RECEIVE_POST_ORDERS_RETURNS: 'RECEIVE_POST_ORDERS_RETURNS',
  ERROR_POST_ORDERS_RETURNS: 'ERROR_POST_ORDERS_RETURNS',

  REQUEST_DELETE_ORDERS_RETURNS: 'REQUEST_DELETE_ORDERS_RETURNS',
  RECEIVE_DELETE_ORDERS_RETURNS: 'RECEIVE_DELETE_ORDERS_RETURNS',
  ERROR_DELETE_ORDERS_RETURNS: 'ERROR_DELETE_ORDERS_RETURNS',

  REQUEST_GET_PACKING_ORDER: 'REQUEST_GET_PACKING_ORDER',
  RECEIVE_GET_PACKING_ORDER: 'RECEIVE_GET_PACKING_ORDER',
  ERROR_GET_PACKING_ORDER: 'ERROR_GET_PACKING_ORDER',

  REQUEST_PUT_PACKING_ORDER: 'REQUEST_PUT_PACKING_ORDER',
  RECEIVE_PUT_PACKING_ORDER: 'RECEIVE_PUT_PACKING_ORDER',
  ERROR_PUT_PACKING_ORDER: 'ERROR_PUT_PACKING_ORDER',

  REQUEST_GET_PACKING_STICKER: 'REQUEST_GET_PACKING_STICKER',
  RECEIVE_GET_PACKING_STICKER: 'RECEIVE_GET_PACKING_STICKER',
  ERROR_GET_PACKING_STICKER: 'ERROR_GET_PACKING_STICKER',

  REQUEST_POST_FBM_DELIVERY_QR_CODE: 'REQUEST_POST_FBM_DELIVERY_QR_CODE',
  RECEIVE_POST_FBM_DELIVERY_QR_CODE: 'RECEIVE_POST_FBM_DELIVERY_QR_CODE',
  ERROR_POST_FBM_DELIVERY_QR_CODE: 'ERROR_POST_FBM_DELIVERY_QR_CODE',

  REQUEST_POST_DRIVER_PERMIT: 'REQUEST_POST_DRIVER_PERMIT',
  RECEIVE_POST_DRIVER_PERMIT: 'RECEIVE_POST_DRIVER_PERMIT',
  ERROR_POST_DRIVER_PERMIT: 'ERROR_POST_DRIVER_PERMIT',

  REQUEST_POST_AUTO_BFO: 'REQUEST_POST_AUTO_BFO',
  RECEIVE_POST_AUTO_BFO: 'RECEIVE_POST_AUTO_BFO',
  ERROR_POST_AUTO_BFO: 'ERROR_POST_AUTO_BFO',

  REQUEST_GET_ORDER_INFO: 'REQUEST_GET_ORDER_INFO',
  RECEIVE_GET_ORDER_INFO: 'RECEIVE_GET_ORDER_INFO',
  ERROR_GET_ORDER_INFO: 'ERROR_GET_ORDER_INFO',

  REQUEST_GET_WAREHOUSE_TYPES: 'REQUEST_GET_WAREHOUSE_TYPES',
  RECEIVE_GET_WAREHOUSE_TYPES: 'RECEIVE_GET_WAREHOUSE_TYPES',
  ERROR_GET_WAREHOUSE_TYPES: 'ERROR_GET_WAREHOUSE_TYPES',

  REQUEST_GET_OZON_TIMESLOTS: 'REQUEST_GET_OZON_TIMESLOTS',
  RECEIVE_GET_OZON_TIMESLOTS: 'RECEIVE_GET_OZON_TIMESLOTS',
  ERROR_GET_OZON_TIMESLOTS: 'ERROR_GET_OZON_TIMESLOTS',

  REQUEST_POST_OZON_DATA: 'REQUEST_POST_OZON_DATA',
  RECEIVE_POST_OZON_DATA: 'RECEIVE_POST_OZON_DATA',
  ERROR_POST_OZON_DATA: 'ERROR_POST_OZON_DATA',
};

export const fetchGetOrdersForOrdersPage = (data) => {
  const { activeTab, filter_states, button_filter, reserved_variant_id } = data;

  let filterStates = null;
  if (activeTab) {
    const currentTab = ORDERS_PAGE_TABS.find((t) => t.id === activeTab);
    if (currentTab) {
      if (activeTab !== 'all') {
        if (!button_filter) {
          filterStates =
            currentTab.states && currentTab.states.length ? currentTab.states.join(',') : '';
        } else {
          filterStates = getStateForButtonFilter(button_filter);
        }
      } else {
        if (filter_states) {
          filterStates = filter_states;
        }
      }
    }
  } else {
    if (filter_states) {
      filterStates = filter_states;
    }
  }

  if (reserved_variant_id && reserved_variant_id.includes('#')) {
    data.reserved_variant_id = encodeURIComponent(reserved_variant_id);
  }

  return fetchGetOrders({
    ...data,
    filter_states: filterStates,
  });
};

let fetchGetOrdersCancel = () => null;

export const fetchGetOrders = (data) => {
  const {
    size,
    search,
    page,
    date_from,
    date_to,
    filter_states,
    delivery_code,
    city,
    variant_id,
    product_article,
    product_barcode,
    problemOrders,
    reserved_variant_id,
    warehouse_code,
    filter_phone,
    filter_tracking_number,
    filter_promocode,
    tags,
    order_types,
    filter_email,
    filter_externalId,
  } = data;

  let url = `${HOST}/api/lite/orders?size=${size}`;
  if (search) url += `&filter_multi=${search}`;
  if (page) url += `&page=${page}`;
  if (date_from) url += `&date_from=${date_from}`;
  if (date_to) url += `&date_to=${date_to}`;
  if (filter_states) url += `&filter_states=${filter_states}`;
  if (delivery_code) url += `&delivery_code=${delivery_code}`;
  if (city) url += `&city=${city}`;
  if (variant_id) url += `&variant_id=${variant_id}`;
  if (product_article) url += `&article=${product_article}`;
  if (product_barcode) url += `&barcode=${product_barcode}`;
  if (problemOrders) url += `&problemOrders=true`;
  if (reserved_variant_id) url += `&reserved_variant_id=${reserved_variant_id}`;
  if (warehouse_code) url += `&warehouse_code=${warehouse_code}`;
  if (filter_phone) url += `&filter_phone=${filter_phone}`;
  if (filter_tracking_number) url += `&filter_tracking_number=${filter_tracking_number}`;
  if (filter_promocode) url += `&filter_promocode=${filter_promocode}`;
  if (tags) url += `&filter_tags=${tags}`;
  if (order_types) url += `&order_types=${order_types}`;
  if (filter_email) url += `&filter_email=${filter_email}`;
  if (filter_externalId) url += `&filter_external_id=${filter_externalId}`;

  return (dispatch, getState) => {
    dispatch(requestGetOrders());
    return new Promise((resolve, reject) => {
      if (cancelSources.getOrders) {
        cancelSources.getOrders('Cancel request');
        cancelSources.getOrders = null;
      }

      const source = axios.CancelToken.source();
      cancelSources.getOrders = source.cancel;

      apiGet({
        url,
        tokens: getState().auth.tokenData,
        cancelToken: source.token,
        callback: (res) => {
          cancelSources.getOrders = null;
          if (res.success) {
            if (res.orders.length === 0) {
              res.orders[0] = 'NOT_FOUND';
            }
            dispatch(receiveGetOrders(res.orders));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrders(err));
            reject(err);
          }
        },
        error: (err) => {
          cancelSources.getOrders = null;
          dispatch(errorGetOrders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrders = () => {
  return {
    type: A.REQUEST_GET_ORDERS,
  };
};

const receiveGetOrders = (data) => {
  return {
    type: A.RECEIVE_GET_ORDERS,
    data,
  };
};

const errorGetOrders = (err) => {
  return {
    type: A.ERROR_GET_ORDERS,
    err,
  };
};

export const fetchGetOrderById = (id) => {
  let url = `${HOST}/api/lite/orders?id=${id}&full_info=true`;
  return (dispatch, getState) => {
    dispatch(requestGetOrderById());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrderById(res.orders[0]));
            resolve(res.orders[0]);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrderById(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrderById(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrderById = () => {
  return {
    type: A.REQUEST_GET_ORDER_BY_ID,
  };
};

const receiveGetOrderById = (data) => {
  return {
    type: A.RECEIVE_GET_ORDER_BY_ID,
    data,
  };
};

const errorGetOrderById = (err) => {
  return {
    type: A.ERROR_GET_ORDER_BY_ID,
    err,
  };
};

export const fetchGetOrdersStatusesLength = (id) => {
  let url = `${HOST}/api/lite/orders/statuses`;
  return (dispatch, getState) => {
    dispatch(requestGetOrdersStatusesLength());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(
              receiveGetOrdersStatusesLength({
                ...res.statuses,
                PROBLEM_ORDERS: res.problemOrders,
              }),
            );
            resolve({ ...res.statuses, PROBLEM_ORDERS: res.problemOrders });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrdersStatusesLength(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrdersStatusesLength(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrdersStatusesLength = () => {
  return {
    type: A.REQUEST_GET_ORDERS_STATUSES_LENGTH,
  };
};

const receiveGetOrdersStatusesLength = (data) => {
  return {
    type: A.RECEIVE_GET_ORDERS_STATUSES_LENGTH,
    data,
  };
};

const errorGetOrdersStatusesLength = (err) => {
  return {
    type: A.ERROR_GET_ORDERS_STATUSES_LENGTH,
    err,
  };
};

export const fetchGetNearestOrders = (id, tags) => {
  let url = `${HOST}/api/lite/orders/nearest/?id=${id}`;
  if (tags) url += `&filter_tags=${tags}`;
  return (dispatch, getState) => {
    dispatch(requestGetNearestOrders());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetNearestOrders(res.orders));
            resolve(res.orders);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetNearestOrders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetNearestOrders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetNearestOrders = () => {
  return {
    type: A.REQUEST_GET_NEAREST_ORDERS,
  };
};

const receiveGetNearestOrders = (data) => {
  return {
    type: A.RECEIVE_GET_NEAREST_ORDERS,
    data,
  };
};

const errorGetNearestOrders = (err) => {
  return {
    type: A.ERROR_GET_NEAREST_ORDERS,
    err,
  };
};

export const fetchCreateOrder = (data) => {
  let url = `${HOST}/api/lite/orders`;
  return (dispatch, getState) => {
    dispatch(requestCreateOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveCreateOrder());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            let order = null;
            if (res.orderId) {
              order = await dispatch(fetchGetOrderById(res.orderId));
            }
            dispatch(errorCreateOrder(err));
            reject({ error: err, order });
          }
        },
        error: (err) => {
          dispatch(errorCreateOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestCreateOrder = () => {
  return {
    type: A.REQUEST_CREATE_ORDER,
  };
};

const receiveCreateOrder = () => {
  return {
    type: A.RECEIVE_CREATE_ORDER,
  };
};

const errorCreateOrder = (err) => {
  return {
    type: A.ERROR_CREATE_ORDER,
    err,
  };
};

export const fetchUpdateOrder = (data) => {
  let url = `${HOST}/api/lite/orders`;
  return (dispatch, getState) => {
    dispatch(requestUpdateOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrder());
            const result = await dispatch(fetchGetOrderById(data.id));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrder = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER,
  };
};

const receiveUpdateOrder = () => {
  return {
    type: A.RECEIVE_UPDATE_ORDER,
  };
};

const errorUpdateOrder = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER,
    err,
  };
};

export const fetchUpdateOrderItems = (data) => {
  let url = `${HOST}/api/lite/orders/items`;
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderItems());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderItems());
            const result = await dispatch(fetchGetOrderById(data.id));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderItems(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderItems(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderItems = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_ITEMS,
  };
};

const receiveUpdateOrderItems = () => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_ITEMS,
  };
};

const errorUpdateOrderItems = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_ITEMS,
    err,
  };
};

export const fetchUpdateOrderClient = (data) => {
  let url = `${HOST}/api/lite/orders/receiver`;
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderClient());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderClient());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderClient(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderClient(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderClient = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_CLIENT,
  };
};

const receiveUpdateOrderClient = () => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_CLIENT,
  };
};

const errorUpdateOrderClient = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_CLIENT,
    err,
  };
};

export const fetchConfirmOrder = (data) => {
  let url = `${HOST}/api/lite/orders/confirm`;
  return (dispatch, getState) => {
    dispatch(requestConfirmOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveConfirmOrder());
            const result = await dispatch(fetchGetOrderById(data.id));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorConfirmOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorConfirmOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestConfirmOrder = () => {
  return {
    type: A.REQUEST_CONFIRM_ORDER,
  };
};

const receiveConfirmOrder = () => {
  return {
    type: A.RECEIVE_CONFIRM_ORDER,
  };
};

const errorConfirmOrder = (err) => {
  return {
    type: A.ERROR_CONFIRM_ORDER,
    err,
  };
};

export const fetchCancelOrder = (data) => {
  let url = `${HOST}/api/lite/orders/cancelled`;
  return (dispatch, getState) => {
    dispatch(requestCancelOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveCancelOrder());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCancelOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCancelOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestCancelOrder = () => {
  return {
    type: A.REQUEST_CANCEL_ORDER,
  };
};

const receiveCancelOrder = () => {
  return {
    type: A.RECEIVE_CANCEL_ORDER,
  };
};

const errorCancelOrder = (err) => {
  return {
    type: A.ERROR_CANCEL_ORDER,
    err,
  };
};

export const fetchGetDeliveryInfo = () => {
  let url = `${HOST}/api/lite/settings/delivery-info-list`;
  return (dispatch, getState) => {
    dispatch(requestGetDeliveryInfo());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetDeliveryInfo(res.deliveryInfoList));
            resolve(res.deliveryInfoList);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetDeliveryInfo(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetDeliveryInfo(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetDeliveryInfo = () => {
  return {
    type: A.REQUEST_GET_DELIVERY_INFO,
  };
};

const receiveGetDeliveryInfo = (data) => {
  return {
    type: A.RECEIVE_GET_DELIVERY_INFO,
    data,
  };
};

const errorGetDeliveryInfo = (err) => {
  return {
    type: A.ERROR_GET_DELIVERY_INFO,
    err,
  };
};

export const fetchGetWarehouses = () => {
  let url = `${HOST}/api/lite/settings/warehouses`;
  return (dispatch, getState) => {
    dispatch(requestGetWarehouses());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetWarehouses(res.warehouses));
            resolve(res.warehouses);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetWarehouses(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetWarehouses(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetWarehouses = () => {
  return {
    type: A.REQUEST_GET_WAREHOUSES,
  };
};

const receiveGetWarehouses = (data) => {
  return {
    type: A.RECEIVE_GET_WAREHOUSES,
    data,
  };
};

const errorGetWarehouses = (err) => {
  return {
    type: A.ERROR_GET_WAREHOUSES,
    err,
  };
};

export const fetchCalcInsuranceSum = (data) => {
  return (dispatch, getState) => {
    dispatch(requestCalcInsuranceSum());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/calc_insurance_sum`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveCalcInsuranceSum(res.insuranceSum));
            resolve(res.insuranceSum);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCalcInsuranceSum(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCalcInsuranceSum(err));
          reject(err);
        },
      });
    });
  };
};

const requestCalcInsuranceSum = () => {
  return {
    type: A.REQUEST_CALC_INSURANCE_SUM,
  };
};

const receiveCalcInsuranceSum = () => {
  return {
    type: A.RECEIVE_CALC_INSURANCE_SUM,
  };
};

const errorCalcInsuranceSum = (err) => {
  return {
    type: A.ERROR_CALC_INSURANCE_SUM,
    err,
  };
};

export const fetchRefreshReserve = (orderId) => {
  let url = `${HOST}/api/lite/orders/refresh-reserve?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestRefreshReserve());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveRefreshReserve());
            const result = await dispatch(fetchGetOrderById(orderId));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRefreshReserve(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRefreshReserve(err));
          reject(err);
        },
      });
    });
  };
};

const requestRefreshReserve = () => {
  return {
    type: A.REQUEST_REFRESH_RESERVE,
  };
};

const receiveRefreshReserve = (data) => {
  return {
    type: A.RECEIVE_REFRESH_RESERVE,
    data,
  };
};

const errorRefreshReserve = (err) => {
  return {
    type: A.ERROR_REFRESH_RESERVE,
    err,
  };
};

export const fetchRefreshReserveBatch = (data) => {
  let url = `${HOST}/api/lite/orders/refresh-reserve/batch`;
  return (dispatch, getState) => {
    dispatch(requestRefreshReserveBatch());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveRefreshReserveBatch());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRefreshReserveBatch(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRefreshReserveBatch(err));
          reject(err);
        },
      });
    });
  };
};

const requestRefreshReserveBatch = () => {
  return {
    type: A.REQUEST_REFRESH_RESERVE_BATCH,
  };
};

const receiveRefreshReserveBatch = (data) => {
  return {
    type: A.RECEIVE_REFRESH_RESERVE_BATCH,
    data,
  };
};

const errorRefreshReserveBatch = (err) => {
  return {
    type: A.ERROR_REFRESH_RESERVE_BATCH,
    err,
  };
};

export const fetchUpdatePaymentStatus = (data) => {
  let url = `${HOST}/api/lite/orders/payment`;
  return (dispatch, getState) => {
    dispatch(requestUpdatePaymentStatus());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveUpdatePaymentStatus());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdatePaymentStatus(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdatePaymentStatus(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdatePaymentStatus = () => {
  return {
    type: A.REQUEST_UPDATE_PAYMENT_STATUS,
  };
};

const receiveUpdatePaymentStatus = () => {
  return {
    type: A.RECEIVE_UPDATE_PAYMENT_STATUS,
  };
};

const errorUpdatePaymentStatus = (err) => {
  return {
    type: A.ERROR_UPDATE_PAYMENT_STATUS,
    err,
  };
};

export const fetchGetOrderHistory = (orderId) => {
  let url = `${HOST}/api/lite/orders/history?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetOrderHistory());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrderHistory(res.events));
            resolve(res.events);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrderHistory(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrderHistory(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrderHistory = () => {
  return {
    type: A.REQUEST_GET_ORDER_HISTORY,
  };
};

const receiveGetOrderHistory = (data) => {
  return {
    type: A.RECEIVE_GET_ORDER_HISTORY,
    data,
  };
};

const errorGetOrderHistory = (err) => {
  return {
    type: A.ERROR_GET_ORDER_HISTORY,
    err,
  };
};

export const fetchGetOrdersExportTasks = () => {
  //TODO PAGINATION
  let url = `${HOST}/api/lite/export/order`;
  return (dispatch, getState) => {
    dispatch(requestGetOrdersExportTasks());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(
              receiveGetOrdersExportTasks({
                tasks: res.exportResults,
                recordsTotal: res.recordsTotal,
              }),
            );
            resolve({ tasks: res.exportResults, recordsTotal: res.recordsTotal });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrdersExportTasks(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrdersExportTasks(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrdersExportTasks = () => {
  return {
    type: A.REQUEST_GET_ORDERS_EXPORT_TASKS,
  };
};

const receiveGetOrdersExportTasks = (data) => {
  return {
    type: A.RECEIVE_GET_ORDERS_EXPORT_TASKS,
    data,
  };
};

const errorGetOrdersExportTasks = (err) => {
  return {
    type: A.ERROR_GET_ORDERS_EXPORT_TASKS,
    err,
  };
};

export const fetchGetOrdersReport = (data) => {
  let url = `${HOST}/api/lite/export/order`;
  return (dispatch, getState) => {
    dispatch(requestGetOrdersReport());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrdersReport());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrdersReport(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrdersReport(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrdersReport = () => {
  return {
    type: A.REQUEST_GET_ORDERS_REPORT,
  };
};

const receiveGetOrdersReport = (data) => {
  return {
    type: A.RECEIVE_GET_ORDERS_REPORT,
    data,
  };
};

const errorGetOrdersReport = (err) => {
  return {
    type: A.ERROR_GET_ORDERS_REPORT,
    err,
  };
};

export const fetchGetOrdersReportById = (reportId) => {
  let url = `${HOST}/api/lite/export/order?id=${reportId}`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetOrderSticker = (orderId) => {
  let url = `${HOST}/api/lite/orders/invoice_and_stiсker?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetOrderSticker());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrderSticker());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrdersReport(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrderSticker(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrderSticker = () => {
  return {
    type: A.REQUEST_GET_ORDER_STICKER,
  };
};

const receiveGetOrderSticker = (data) => {
  return {
    type: A.RECEIVE_GET_ORDER_STICKER,
    data,
  };
};

const errorGetOrderSticker = (err) => {
  return {
    type: A.ERROR_GET_ORDER_STICKER,
    err,
  };
};

export const fetchCopyOrder = (orderId) => {
  let url = `${HOST}/api/lite/orders/copy`;
  return (dispatch, getState) => {
    dispatch(requestCopyOrder());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: { id: orderId },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveCopyOrder());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorCopyOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorCopyOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestCopyOrder = () => {
  return {
    type: A.REQUEST_COPY_ORDER,
  };
};

const receiveCopyOrder = (data) => {
  return {
    type: A.RECEIVE_COPY_ORDER,
    data,
  };
};

const errorCopyOrder = (err) => {
  return {
    type: A.ERROR_COPY_ORDER,
    err,
  };
};

export const fetchUpdateOrderAddress = (data) => {
  let url = `${HOST}/api/lite/orders/receiver/address`;
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderAddress());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderAddress());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderAddress(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderAddress(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderAddress = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_ADDRESS,
  };
};

const receiveUpdateOrderAddress = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_ADDRESS,
    data,
  };
};

const errorUpdateOrderAddress = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_ADDRESS,
    err,
  };
};

export const fetchTags = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    apiGet({
      url: `${HOST}/api/lite/tag`,
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveTags(res.tags));
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          reject(err);
        }
      },
      error: (err) => {
        reject(err);
      },
    });
  });

const receiveTags = (data) => ({
  type: A.REQUEST_TAGS,
  data,
});

export const fetchUpdateTags = (data) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    apiPost({
      url: `${HOST}/api/lite/tag`,
      tokens: getState().auth.tokenData,
      body: data,
      callback: (res) => {
        if (res.success) {
          dispatch(fetchTags());
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          reject(err);
        }
      },
      error: (err) => {
        reject(err);
      },
    });
  });

export const fetchAssignTagToOrder = (data) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    apiPost({
      url: `${HOST}/api/lite/orders/tag`,
      tokens: getState().auth.tokenData,
      body: data,
      callback: (res) => {
        if (res.success) {
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          reject(err);
        }
      },
      error: (err) => {
        reject(err);
      },
    });
  });

export const fetchRemoveTagFromOrder = (data) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    apiDelete({
      url: `${HOST}/api/lite/order/tag`,
      tokens: getState().auth.tokenData,
      body: data,
      callback: (res) => {
        if (res.success) {
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          reject(err);
        }
      },
      error: (err) => {
        reject(err);
      },
    });
  });

export const fetchUploadOrderFile = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return (dispatch, getState) => {
    dispatch(requestUploadOrderFile());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/file`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUploadOrderFile(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUploadOrderFile(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUploadOrderFile(err));
          reject(err);
        },
      });
    });
  };
};

const requestUploadOrderFile = () => {
  return {
    type: A.REQUEST_UPLOAD_ORDER_FILE,
  };
};

const receiveUploadOrderFile = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_ORDER_FILE,
    data,
  };
};

const errorUploadOrderFile = (err) => {
  return {
    type: A.ERROR_UPLOAD_ORDER_FILE,
    err,
  };
};

export const fetchDeleteOrderFile = (fileId) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteOrderFile());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/orders/file?id=${fileId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteOrderFile(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteOrderFile(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteOrderFile(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteOrderFile = () => {
  return {
    type: A.REQUEST_DELETE_ORDER_FILE,
  };
};

const receiveDeleteOrderFile = (data) => {
  return {
    type: A.RECEIVE_DELETE_ORDER_FILE,
    data,
  };
};

const errorDeleteOrderFile = (err) => {
  return {
    type: A.ERROR_DELETE_ORDER_FILE,
    err,
  };
};

export const fetchEditOrderFile = (data) => {
  return (dispatch, getState) => {
    dispatch(requestEditOrderFile());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/file/edit`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveEditOrderFile(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEditOrderFile(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEditOrderFile(err));
          reject(err);
        },
      });
    });
  };
};

const requestEditOrderFile = () => {
  return {
    type: A.REQUEST_EDIT_ORDER_FILE,
  };
};

const receiveEditOrderFile = (data) => {
  return {
    type: A.RECEIVE_EDIT_ORDER_FILE,
    data,
  };
};

const errorEditOrderFile = (err) => {
  return {
    type: A.ERROR_EDIT_ORDER_FILE,
    err,
  };
};

export const fetchGetOrdersCount = (data) => {
  //TODO привести к общему виду
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/export/order/count`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchEmailRepeat = (data) => {
  return (dispatch, getState) => {
    dispatch(requestEmailRepeat());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/email/repeat`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveEmailRepeat(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEmailRepeat(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEmailRepeat(err));
          reject(err);
        },
      });
    });
  };
};

const requestEmailRepeat = () => {
  return {
    type: A.REQUEST_EMAIL_REPEAT,
  };
};

const receiveEmailRepeat = (data) => {
  return {
    type: A.RECEIVE_EMAIL_REPEAT,
    data,
  };
};

const errorEmailRepeat = (err) => {
  return {
    type: A.ERROR_EMAIL_REPEAT,
    err,
  };
};

export const fetchPostOrderSync = (id) => {
  //TODO Привести к нормальному виду
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/sync_ff`,
        tokens: getState().auth.tokenData,
        body: { id: id },
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchUpdateOrderDelivery = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderDelivery());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/delivery`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderDelivery(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderDelivery(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderDelivery(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderDelivery = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_DELIVERY,
  };
};

const receiveUpdateOrderDelivery = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_DELIVERY,
    data,
  };
};

const errorUpdateOrderDelivery = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_DELIVERY,
    err,
  };
};

export const fetchUpdateOrderDiscounts = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderDiscounts());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/discounts`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderDiscounts(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderDiscounts(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderDiscounts(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderDiscounts = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_DISCOUNTS,
  };
};

const receiveUpdateOrderDiscounts = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_DISCOUNTS,
    data,
  };
};

const errorUpdateOrderDiscounts = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_DISCOUNTS,
    err,
  };
};

export const fetchUpdateOrderComment = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderComment());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/comments`,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderComment(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderComment(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderComment(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrderComment = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_COMMENT,
  };
};

const receiveUpdateOrderComment = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_COMMENT,
    data,
  };
};

const errorUpdateOrderComment = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_COMMENT,
    err,
  };
};

export const fetchUpdateWarehouseSetting = (warehouse) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/warehouses`,
        tokens: getState().auth.tokenData,
        body: warehouse,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderComment(err));
          reject(err);
        },
      });
    });
  };
};

export const fetchPostWBBarcodes = (orderId, file) => {
  const formData = new FormData();
  formData.append(`file`, file);
  formData.append(`order_id`, orderId);
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/add_wb_barcodes`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchRefreshAllReserves = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/refresh-reserve/all`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetWorksheetFormTemplate = (orderId) => {
  let url = `${HOST}/api/lite/orders/worksheet/form_template?order_id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetWorksheetFormTemplate());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetWorksheetFormTemplate(res.requirements));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetWorksheetFormTemplate(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetWorksheetFormTemplate(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetWorksheetFormTemplate = () => {
  return {
    type: A.REQUEST_GET_WORKSHEET_FORM_TEMPLATE,
  };
};

const receiveGetWorksheetFormTemplate = (data) => {
  return {
    type: A.RECEIVE_GET_WORKSHEET_FORM_TEMPLATE,
    data,
  };
};

const errorGetWorksheetFormTemplate = (err) => {
  return {
    type: A.ERROR_GET_WORKSHEET_FORM_TEMPLATE,
    err,
  };
};

export const fetchGetWorksheet = (orderId) => {
  let url = `${HOST}/api/lite/orders/worksheet/?orderId=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetWorksheet());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            const item = res.form_content.find((item) => item.id === 'shipment_destination');
            if (item) {
              dispatch(receiveGetWorksheetShipmentCode(item.value));
            }
            dispatch(receiveGetWorksheet());
            resolve(res.form_content);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetWorksheet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetWorksheet(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetWorksheet = () => {
  return {
    type: A.REQUEST_GET_WORKSHEET,
  };
};

const receiveGetWorksheet = (data) => {
  return {
    type: A.RECEIVE_GET_WORKSHEET,
    data,
  };
};

const receiveGetWorksheetShipmentCode = (data) => {
  return {
    type: A.RECEIVE_GET_WORKSHEET_SHIPMENT_CODE,
    data,
  };
};

const errorGetWorksheet = (err) => {
  return {
    type: A.ERROR_GET_WORKSHEET,
    err,
  };
};

export const fetchUpdateWorksheet = (data) => {
  let url = `${HOST}/api/lite/orders/worksheet/`;
  return (dispatch, getState) => {
    dispatch(requestUpdateWorksheet());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateWorksheet());
            resolve(data.form_content);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateWorksheet(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateWorksheet(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateWorksheet = () => {
  return {
    type: A.REQUEST_UPDATE_WORKSHEET,
  };
};

const receiveUpdateWorksheet = (data) => {
  return {
    type: A.RECEIVE_UPDATE_WORKSHEET,
    data,
  };
};

const errorUpdateWorksheet = (err) => {
  return {
    type: A.ERROR_UPDATE_WORKSHEET,
    err,
  };
};

export const fetchUploadFbmDocsFF = (data) => {
  let url = `${HOST}/api/lite/orders/upload_fbm_docs_ff`;
  return (dispatch, getState) => {
    dispatch(requestUploadFbmDocsFF());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUploadFbmDocsFF());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUploadFbmDocsFF(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUploadFbmDocsFF(err));
          reject(err);
        },
      });
    });
  };
};

const requestUploadFbmDocsFF = () => {
  return {
    type: A.REQUEST_UPLOAD_FBM_DOCS_FF,
  };
};

const receiveUploadFbmDocsFF = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_FBM_DOCS_FF,
    data,
  };
};

const errorUploadFbmDocsFF = (err) => {
  return {
    type: A.ERROR_UPLOAD_FBM_DOCS_FF,
    err,
  };
};

export const fetchExportOrderExcel = (id) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/export/order/now?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res.exportResults[0]);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchOrderInvoice = (id) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/export/order/invoice?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res.exportResults[0]);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchUploadFbmStickersXls = (formData) => {
  return (dispatch, getState) => {
    dispatch(requestUploadFbmStickersXls());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/orders/packing/fbm/sticker/xls`,
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUploadFbmStickersXls(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUploadFbmStickersXls(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUploadFbmStickersXls(err));
          reject(err);
        },
      });
    });
  };
};

const requestUploadFbmStickersXls = () => {
  return {
    type: A.REQUEST_UPLOAD_FBM_STICKERS_XLS,
  };
};

const receiveUploadFbmStickersXls = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_FBM_STICKERS_XLS,
    data,
  };
};

const errorUploadFbmStickersXls = (err) => {
  return {
    type: A.ERROR_UPLOAD_FBM_STICKERS_XLS,
    err,
  };
};

export const fetchGetFbmBarcodesXls = (orderId) => {
  let url = `${HOST}/api/lite/orders/packing/fbm/sticker/xls?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetFbmBarcodesXls());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetFbmBarcodesXls());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetFbmBarcodesXls(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetFbmBarcodesXls(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetFbmBarcodesXls = () => {
  return {
    type: A.REQUEST_GET_FBM_BARCODES_XLS,
  };
};

const receiveGetFbmBarcodesXls = (data) => {
  return {
    type: A.RECEIVE_GET_FBM_BARCODES_XLS,
    data,
  };
};

const errorGetFbmBarcodesXls = (err) => {
  return {
    type: A.ERROR_GET_FBM_BARCODES_XLS,
    err,
  };
};

export const fetchUploadFbmStickersPalletFile = (data, file64) => (dispatch, getState) => {
  dispatch(requestUploadFbmStickersPalletFile());
  setOsticketHeaders(getState);
  return axios
    .post(HOST + '/api/lite/orders/pallet/fbm/sticker/file/json', file64, osTicketConfig)
    .then((res) => {
      if (res.data.success) {
        dispatch(receiveUploadFbmStickersPalletFile(res));
        return res;
      } else {
        const err = res;

        dispatch(errorUploadFbmStickersPalletFile(err));
        throw err;
      }
    })
    .catch((err) => {
      dispatch(errorUploadFbmStickersPalletFile(err));
      throw err;
    });
};

const requestUploadFbmStickersPalletFile = () => {
  return {
    type: A.REQUEST_UPLOAD_FBM_STICKERS_PALLET_FILE,
  };
};

const receiveUploadFbmStickersPalletFile = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_FBM_STICKERS_PALLET_FILE,
    data,
  };
};

const errorUploadFbmStickersPalletFile = (err) => {
  return {
    type: A.ERROR_UPLOAD_FBM_STICKERS_PALLET_FILE,
    err,
  };
};

export const fetchDeleteFbmStickersPalletFile = (fileId) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteFbmStickersPalletFile());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/orders/pallet/fbm/sticker/file?id=${fileId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteFbmStickersPalletFile(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteFbmStickersPalletFile(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteFbmStickersPalletFile(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteFbmStickersPalletFile = () => {
  return {
    type: A.REQUEST_DELETE_FBM_STICKERS_PALLET_FILE,
  };
};

const receiveDeleteFbmStickersPalletFile = (data) => {
  return {
    type: A.RECEIVE_DELETE_FBM_STICKERS_PALLET_FILE,
    data,
  };
};

const errorDeleteFbmStickersPalletFile = (err) => {
  return {
    type: A.ERROR_DELETE_FBM_STICKERS_PALLET_FILE,
    err,
  };
};

export const fetchUploadFbmStickersPackingFile = (data, file64) => (dispatch, getState) => {
  dispatch(requestUploadFbmStickersPackingFile());
  setOsticketHeaders(getState);
  return axios
    .post(HOST + '/api/lite/orders/packing/fbm/sticker/file/json', file64, osTicketConfig)
    .then((res) => {
      if (res.data.success) {
        dispatch(receiveUploadFbmStickersPackingFile(res));
        return res;
      } else {
        const err = res;

        dispatch(errorUploadFbmStickersPackingFile(err));
        throw err;
      }
    })
    .catch((err) => {
      dispatch(errorUploadFbmStickersPackingFile(err));
      throw err;
    });
};

const requestUploadFbmStickersPackingFile = () => {
  return {
    type: A.REQUEST_UPLOAD_FBM_STICKERS_PACKING_FILE,
  };
};

const receiveUploadFbmStickersPackingFile = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_FBM_STICKERS_PACKING_FILE,
    data,
  };
};

const errorUploadFbmStickersPackingFile = (err) => {
  return {
    type: A.ERROR_UPLOAD_FBM_STICKERS_PACKING_FILE,
    err,
  };
};

export const fetchOrderExcludeChange = (data) => {
  let url = `${HOST}/api/lite/order-exclude-change`;
  return (dispatch, getState) => {
    dispatch(requestOrderExcludeChange());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receiveOrderExcludeChange());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorOrderExcludeChange(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorOrderExcludeChange(err));
          reject(err);
        },
      });
    });
  };
};

const requestOrderExcludeChange = () => {
  return {
    type: A.REQUEST_ORDER_EXCLUDE_CHANGE,
  };
};

const receiveOrderExcludeChange = (data) => {
  return {
    type: A.RECEIVE_ORDER_EXCLUDE_CHANGE,
    data,
  };
};

const errorOrderExcludeChange = (err) => {
  return {
    type: A.ERROR_ORDER_EXCLUDE_CHANGE,
    err,
  };
};

export const fetchGetOrdersReturns = (orderId) => {
  let url = `${HOST}/api/lite/orders/returns?orderId=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetOrdersReturns());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        // body: {
        //   orderId: orderId,
        // },
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrdersReturns(res.returns));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrdersReturns(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrdersReturns(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrdersReturns = () => {
  return {
    type: A.REQUEST_GET_ORDERS_RETURNS,
  };
};

const receiveGetOrdersReturns = (data) => {
  return {
    type: A.RECEIVE_GET_ORDERS_RETURNS,
    data,
  };
};

const errorGetOrdersReturns = (err) => {
  return {
    type: A.ERROR_GET_ORDERS_RETURNS,
    err,
  };
};

export const fetchPostOrdersReturns = (body) => {
  let url = `${HOST}/api/lite/orders/returns`;
  return (dispatch, getState) => {
    dispatch(requestPostOrdersReturns());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostOrdersReturns(res.returns));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostOrdersReturns(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOrdersReturns(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOrdersReturns = () => {
  return {
    type: A.REQUEST_POST_ORDERS_RETURNS,
  };
};

const receivePostOrdersReturns = (data) => {
  return {
    type: A.RECEIVE_POST_ORDERS_RETURNS,
    data,
  };
};

const errorPostOrdersReturns = (err) => {
  return {
    type: A.ERROR_POST_ORDERS_RETURNS,
    err,
  };
};

export const fetchDeletePostOrdersReturns = (orderId) => {
  return (dispatch, getState) => {
    dispatch(requestDeletePostOrdersReturns());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/orders/returns?orderId=${orderId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeletePostOrdersReturns(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeletePostOrdersReturns(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeletePostOrdersReturns(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeletePostOrdersReturns = () => {
  return {
    type: A.REQUEST_DELETE_ORDERS_RETURNS,
  };
};

const receiveDeletePostOrdersReturns = (data) => {
  return {
    type: A.RECEIVE_DELETE_ORDERS_RETURNS,
    data,
  };
};

const errorDeletePostOrdersReturns = (err) => {
  return {
    type: A.ERROR_DELETE_ORDERS_RETURNS,
    err,
  };
};

/*
 * Получение упакованных мест заказа
 */

export const fetchGetPackingOrder = (orderId) => {
  let url = `${HOST}/api/lite/orders/consolidation/packing?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetPackingOrder());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPackingOrder());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPackingOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPackingOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPackingOrder = () => {
  return {
    type: A.REQUEST_GET_PACKING_ORDER,
  };
};

const receiveGetPackingOrder = (data) => {
  return {
    type: A.RECEIVE_GET_PACKING_ORDER,
    data,
  };
};

const errorGetPackingOrder = (err) => {
  return {
    type: A.ERROR_GET_PACKING_ORDER,
    err,
  };
};

/*
 * Создание/редактирование заказа поштучно
 */

export const fetchPutPackingOrder = (data) => {
  let url = `${HOST}/api/lite/orders/consolidation/packing`;
  return (dispatch, getState) => {
    dispatch(requestPutPackingOrder());
    return new Promise((resolve, reject) => {
      apiPut({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receivePutPackingOrder());
            resolve(res);
            toast.info('Заказ успешно обновлен');
            dispatch(hideModal());
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPutPackingOrder(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPutPackingOrder(err));
          reject(err);
        },
      });
    });
  };
};

const requestPutPackingOrder = () => {
  return {
    type: A.REQUEST_PUT_PACKING_ORDER,
  };
};

const receivePutPackingOrder = (data) => {
  return {
    type: A.RECEIVE_PUT_PACKING_ORDER,
    data,
  };
};

const errorPutPackingOrder = (err) => {
  return {
    type: A.ERROR_PUT_PACKING_ORDER,
    err,
  };
};

/* Получение стикера упаковочного места */

export const fetchGetPackingSticker = (barcode) => {
  let url = `${HOST}/api/lite/orders/consolidation/packing/print?barcode=${barcode}`;
  return (dispatch, getState) => {
    dispatch(requestGetPackingSticker());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPackingSticker());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPackingSticker(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPackingSticker(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPackingSticker = () => {
  return {
    type: A.REQUEST_GET_PACKING_STICKER,
  };
};

const receiveGetPackingSticker = (data) => {
  return {
    type: A.RECEIVE_GET_PACKING_STICKER,
    data,
  };
};

const errorGetPackingSticker = (err) => {
  return {
    type: A.ERROR_GET_PACKING_STICKER,
    err,
  };
};

export const fetchPostFbmDeliveryQrCode = (body) => {
  let url = `${HOST}/api/lite/orders/worksheet/fbm/sticker/use/file`;
  return (dispatch, getState) => {
    dispatch(requestPostFbmDeliveryQrCode());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostFbmDeliveryQrCode());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostFbmDeliveryQrCode(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostFbmDeliveryQrCode(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostFbmDeliveryQrCode = () => {
  return {
    type: A.REQUEST_POST_FBM_DELIVERY_QR_CODE,
  };
};

const receivePostFbmDeliveryQrCode = () => {
  return {
    type: A.RECEIVE_POST_FBM_DELIVERY_QR_CODE,
  };
};

const errorPostFbmDeliveryQrCode = (err) => {
  return {
    type: A.ERROR_POST_FBM_DELIVERY_QR_CODE,
    err,
  };
};

export const fetchGetDeliveryRawStatuses = (id) => {
  let url = `${HOST}/api/lite/orders/delivery/raw/statuses?id=${id}`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            reject(err);
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchPostDriverPermit = (data) => {
  let url = `${HOST}/api/lite/orders/fbm_driver_permit_uploaded`;
  return (dispatch, getState) => {
    dispatch(requestPostDriverPermit());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostDriverPermit());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostDriverPermit(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostDriverPermit(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostDriverPermit = () => {
  return {
    type: A.REQUEST_POST_DRIVER_PERMIT,
  };
};

const receivePostDriverPermit = () => {
  return {
    type: A.RECEIVE_POST_DRIVER_PERMIT,
  };
};

const errorPostDriverPermit = (err) => {
  return {
    type: A.ERROR_POST_DRIVER_PERMIT,
    err,
  };
};

export const fetchPostOzonFbo = (data) => {
  let url = `${HOST}/api/lite/orders/fbo/auto/info/mode`;
  return (dispatch, getState) => {
    dispatch(requestPostAutoFbo());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostAutoFbo());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(parseError(err));
            dispatch(errorPostAutoFbo(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorPostAutoFbo(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostAutoFbo = () => {
  return {
    type: A.REQUEST_POST_AUTO_BFO,
  };
};

const receivePostAutoFbo = () => {
  return {
    type: A.RECEIVE_POST_AUTO_BFO,
  };
};

const errorPostAutoFbo = (err) => {
  return {
    type: A.ERROR_POST_AUTO_BFO,
    err,
  };
};

export const fetchGetOzonInfo = (data) => {
  let url = `${HOST}/api/lite/orders/fbo/auto?orderId=${data}`;
  return (dispatch, getState) => {
    dispatch(requestGetOrderInfo());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrderInfo(res.ozonFboInfo));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(parseError(err));
            dispatch(errorGetErrorInfo(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorGetErrorInfo(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrderInfo = () => {
  return {
    type: A.REQUEST_GET_ORDER_INFO,
  };
};

const receiveGetOrderInfo = (data) => {
  return {
    type: A.RECEIVE_GET_ORDER_INFO,
    data,
  };
};

const errorGetErrorInfo = (err) => {
  return {
    type: A.ERROR_GET_ORDER_INFO,
    err,
  };
};

export const fetchGetWarehouseTypes = (body) => {
  let url = `${HOST}/api/lite/orders/fbo/auto/warehouse/list`;
  return (dispatch, getState) => {
    dispatch(requestGetWarehouseTypes());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetWarehouseTypes(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(parseError(err));
            dispatch(errorGetWarehouseTypes(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorGetWarehouseTypes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetWarehouseTypes = () => {
  return {
    type: A.REQUEST_GET_WAREHOUSE_TYPES,
  };
};

const receiveGetWarehouseTypes = (data) => {
  return {
    type: A.RECEIVE_GET_WAREHOUSE_TYPES,
    data,
  };
};

const errorGetWarehouseTypes = (err) => {
  return {
    type: A.ERROR_GET_WAREHOUSE_TYPES,
    err,
  };
};

export const fetchGetOzonTimeslots = (body) => {
  let url = `${HOST}/api/lite/orders/fbo/auto/timeslots`;
  return (dispatch, getState) => {
    dispatch(requestGetOzonTimeSlots());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        tokens: getState().auth.tokenData,
        body,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOzonTimeSlots(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(parseError(err));
            dispatch(errorGetOzonTimeSlots(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorGetOzonTimeSlots(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOzonTimeSlots = () => {
  return {
    type: A.REQUEST_GET_OZON_TIMESLOTS,
  };
};

const receiveGetOzonTimeSlots = (data) => {
  return {
    type: A.RECEIVE_GET_OZON_TIMESLOTS,
    data,
  };
};

const errorGetOzonTimeSlots = (err) => {
  return {
    type: A.ERROR_GET_OZON_TIMESLOTS,
    err,
  };
};

export const fetchPostOzonData = ({ id, data }) => {
  let url = `${HOST}/api/lite/orders/fbo/auto?orderId=${id}`;
  return (dispatch, getState) => {
    dispatch(requestPostOzonData());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            dispatch(receivePostOzonData());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(res.errors[0].message || 'Ошибка при сохранении интервалов');
            dispatch(errorPostOzonData(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOzonData(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOzonData = () => {
  return {
    type: A.REQUEST_POST_OZON_DATA,
  };
};

const receivePostOzonData = (data) => {
  return {
    type: A.RECEIVE_POST_OZON_DATA,
    data,
  };
};

const errorPostOzonData = (err) => {
  return {
    type: A.ERROR_POST_OZON_DATA,
    err,
  };
};
